import React from 'react';
import { CreditCardIcon, MailIcon, PrinterIcon } from 'lucide-react';
import { CURRENCY_NOTE, PRICE, PRICE_PLN } from '../data/valueStack';
import { SUPPORT_EMAIL } from '../data/contact';
import { Eyebrow } from './Eyebrow';
const steps = [{
  icon: CreditCardIcon,
  title: 'Płacisz raz',
  text: `${PRICE} (${PRICE_PLN}) kartą, Google Pay lub Apple Pay. ${CURRENCY_NOTE}`
}, {
  icon: MailIcon,
  title: 'Dostajesz e-mail',
  text: 'W ciągu kilku minut wysyłamy link do pobrania wszystkich 6 tomów, planu semestru i 5 bonusów. Sprawdź też folder Spam lub Oferty.'
}, {
  icon: PrinterIcon,
  title: 'Drukujesz i uczysz',
  text: 'Pliki PDF zostają u Ciebie na zawsze. Bez logowania, bez subskrypcji, bez platformy.'
}];
export function HowItWorks() {
  return <section aria-labelledby="how-heading" className="bg-night py-16 sm:py-24" data-id="element-204" data-mp="14imd8tjf2a6s">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-205" data-mp="199m69npf0840">
        <div className="mx-auto max-w-3xl text-center" data-id="element-206" data-mp="19bfhlgaz3gic">
          <Eyebrow align="center" data-id="element-207" data-mp="2rl4rmtg1xmzo">Co się stanie po kliknięciu?</Eyebrow>
          <h2 id="how-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-208" data-mp="2mml3qnhwe14o">
            Trzy proste kroki<span className="text-amber" data-id="element-209" data-mp="31bzb5q1wy8hf"> i masz wszystko</span>
          </h2>
        </div>
        <ol className="mt-10 grid gap-5 sm:mt-12 lg:grid-cols-3 lg:gap-6" data-id="element-210" data-mp="2wk8z9fnbvcnw">
          {steps.map(({
          icon: Icon,
          title,
          text
        }, index) => <li key={title} className="flex flex-col rounded-2xl border border-night-600 bg-night-800 p-6 sm:p-7" data-id="element-211" data-mp="3aaks5grqlfg3" data-mpi={index}>
              <div className="flex items-center gap-4" data-id="element-212" data-mp="36aaklzoaqgz4">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-amber-deep" data-id="element-213" data-mp="3kalhbjcaeps7">
                  <Icon className="h-5 w-5 text-amber" aria-hidden="true" data-id="element-214" data-mp="3fcjxgw71emfo" />
                </span>
                <span className="text-[11px] font-semibold uppercase tracking-label text-amber" data-id="element-215" data-mp="1px3p3j0xt4qu">
                  Krok {index + 1}
                </span>
              </div>
              <h3 className="mt-6 font-display text-2xl leading-tight text-cream" data-id="element-216" data-mp="3l00d0o4ts489">{title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-cream-soft" data-id="element-217" data-mp="3py1wha65y5k9">{text}</p>
            </li>)}
        </ol>
        <p className="mt-10 text-center text-sm text-cream-soft" data-id="element-218" data-mp="3tz3wvubtgnnt">
          Masz pytanie przed zakupem? Napisz:{' '}
          <a href={`mailto:${SUPPORT_EMAIL}`} className="font-semibold text-amber underline decoration-amber/40 underline-offset-2 transition-colors duration-150 ease-out hover:text-amber-light" data-id="element-219" data-mp="2vf8udcguum3">
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    </section>;
}